import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

// import { PublicServerPlaceEvent, ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { fromDto as notificationFromDto } from '../../../models/adapters/NotificationAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
// import getProtectedResponse from '../getProtectedResponse';
// import getAuthenticationToken from '../getAuthenticationToken';
import FetchPayload from '../../actions/FetchPayload';
import {
  fetchNotifications,
  notificationsFetched,
  notificationsFetchFailed,
  NotificationsFetchResponsePayload,
} from '../../actions/notification/fetchNotifications';

function createFetchNotificationsResponseAction(response): Action<NotificationsFetchResponsePayload> {
  const { error, notifications } = response;
  const timestamp = moment();
  if (!error) {
    return notificationsFetched({
      notifications: notifications.map((notification) => notificationFromDto(notification)),
      timestamp: moment(timestamp),
    });
  }
  return notificationsFetchFailed({ timestamp });
}

function* fetchNotificationsSaga({ payload }: Action<FetchPayload>) {
  // const token = yield getAuthenticationToken(); TODO 121: Create notification when a guest creates a reservation
  const { fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = { error: 'refactor ' };
  // yield getProtectedResponse(ProtectedServerPlaceEvent.getNotifications, token, { }); TODO 121: Create notification when a guest creates a reservation
  const responseAction = createFetchNotificationsResponseAction(response);
  yield put(responseAction);
}

export default function* watchFetchNotificationsSaga() {
  yield takeEvery(fetchNotifications, fetchNotificationsSaga);
}
